// Mutation hook - usuniecie zalacznika
// DELETE /api/ui/sales-crm/deals/{id}/attachments/{attachmentId}

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

interface IDeleteDealAttachmentResponse {
  data?: { id?: number };
  message?: string;
  status?: string;
}

interface IDeleteDealAttachmentVariables {
  dealId: number;
  attachmentId: number;
}

const deleteDealAttachment = ({ dealId, attachmentId }: IDeleteDealAttachmentVariables): Promise<IDeleteDealAttachmentResponse> =>
  axios.delete(`/sales-crm/deals/${dealId}/attachments/${attachmentId}`);

export const useDeleteDealAttachment = (
  options?: UseMutationOptions<IDeleteDealAttachmentResponse, IError, IDeleteDealAttachmentVariables>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IDeleteDealAttachmentResponse, IError, IDeleteDealAttachmentVariables>(deleteDealAttachment, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(['sales-crm-deal-attachments', variables.dealId]);
      await queryClient.refetchQueries(['sales-crm-deal-attachments', variables.dealId]);
      options?.onSuccess?.(data, variables, context);
    },
  });
};
